import React from 'react';
import styled from 'styled-components';

import Card from '../Card/Card';
import defaultImage from '../../assets/images/bg.jpg';


const Wrapper = styled.div`
    background-image: url(${({backgroundImage}) => backgroundImage ? backgroundImage : defaultImage});
    background-repeat: no-repeat;
    background-size: 150%;
    background-attachment: fixed;

    width: 100%;
    height: auto;
    display: flex;
    /* grid-template-columns: repeat(4, 0.8fr);
    gap: 40px; */
    flex-direction: row;
    justify-content: space-around;
    padding: 2rem 8rem 6rem;
    flex-wrap: wrap;
    /* justify-items: center;
    align-items: center; */

    @media (max-width: 1400px) {
        /* grid-template-columns: repeat(3, 0.8fr);
        ${({fourItems}) => fourItems ? "div:nth-of-type(4) { grid-column: 2/3; }" : null}; */
        background-size: 250%;
    }

    @media (max-width: 1080px) {
        padding: 2rem 4rem 6rem;
        background-size: 350%;
    }

    
    
    
`;

const InfoWrapper = (props) => {
    return (
        <Wrapper fourItems={props.fourItems} className="infoWrapper">
            {props.content.map(item => (
                    <Card 
                    key={item.title} 
                    title={item.title} 
                    text={item.text} 
                    image={item.image} 
                    alt={item.alt} 
                    link={item.link ? item.link : null} resize={props.resize}
                    items={item.items}
                    target={item.target}
                    />
    ))}
        </Wrapper>
    )
};

export default InfoWrapper